const PREFIX = 'kelimo-lists:';
function readCachedLists(storage, username, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(PREFIX + username));
    if (!value || now - value.savedAt > 300000) return {};
    return Object.fromEntries(Object.entries(value.lists || {}).filter(([, list]) => Array.isArray(list)));
  } catch { return {}; }
}
function cacheLists(storage, username, lists) {
  try { storage.setItem(PREFIX + username, JSON.stringify({ savedAt: Date.now(), lists })); } catch {}
}

// One latest request per list; timeout also settles if a suspended fetch ignores abort.
function createGameListLoader({ fetchList, onStart, onData, onError, onFinish, timeoutMs = 8000 }) {
  const requests = new Map();
  let disposed = false;
  function cancel(key) {
    const previous = requests.get(key);
    if (!previous) return;
    requests.delete(key);
    clearTimeout(previous.timer);
    previous.controller.abort();
    previous.reject(new Error('Superseded'));
  }
  async function load(key) {
    if (disposed) return;
    cancel(key);
    const controller = new AbortController();
    const request = { controller };
    const deadline = new Promise((_, reject) => {
      request.reject = reject;
      request.timer = setTimeout(() => {
        controller.abort();
        reject(new Error('Liste isteği zaman aşımına uğradı.'));
      }, timeoutMs);
    });
    requests.set(key, request);
    onStart(key);
    try {
      const data = await Promise.race([Promise.resolve().then(() => fetchList(key, controller.signal)), deadline]);
      if (!disposed && requests.get(key) === request) onData(key, Array.isArray(data) ? data : []);
    } catch (error) {
      if (!disposed && requests.get(key) === request) onError(key, error);
    } finally {
      clearTimeout(request.timer);
      if (!disposed && requests.get(key) === request) {
        requests.delete(key);
        onFinish(key);
      }
    }
  }
  function dispose() {
    disposed = true;
    for (const key of requests.keys()) cancel(key);
  }
  return { load, dispose };
}
module.exports = { readCachedLists, cacheLists, createGameListLoader };
